import { FormControl, FormLabel, MenuItem, Select } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from './emptySelect';

export const AvailabilityZoneSelect = ({
  accountId,
  regionName,
  availabilityZone,
  onChange,
  cloudProvider,
  isRequired = false,
}: {
  accountId?: string;
  regionName?: string;
  availabilityZone?: string;
  onChange: (availabilityZone: string) => void;
  cloudProvider?: string;
  isRequired?: boolean;
}) => {
  const title = `${cloudProvider === Provider.Gcp ? 'Zone' : 'Availability Zone'}${isRequired ? '*' : ''}`;

  if (!accountId || !regionName) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerAvailabilityZoneSelect
      accountId={accountId}
      regionName={regionName}
      availabilityZone={availabilityZone}
      onChange={onChange}
      title={title}
    />
  );
};

const InnerAvailabilityZoneSelect = ({
  accountId,
  regionName,
  availabilityZone,
  onChange,
  title,
}: {
  accountId: string;
  regionName: string;
  availabilityZone?: string;
  onChange: (availabilityZone: string) => void;
  title: string;
}) => {
  const dal = useDAL();
  const { data: body } = dal.restore.availabilityZones.list(
    accountId,
    regionName
  );

  if (!body?.availabilityZones.length) {
    return <EmptySelect title={title} />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Select
        size='small'
        value={availabilityZone || ''}
        onChange={(event) => onChange(event.target.value)}
      >
        {body.availabilityZones.map((availabilityZone) => (
          <MenuItem key={availabilityZone} value={availabilityZone}>
            {availabilityZone}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
